const options = {
    "viewType": "grid",
    "grid": {
        "type": "compact",
        "title": "",
        "showFilter": true,
        "showHeaders": true,
        "showTotals": "on",
        "showGrandTotals": "on",
        "showExtraTotalLabels": false,
        "showHierarchies": true,
        "showHierarchyCaptions": true,
        "showReportFiltersArea": true
    },
    "chart": {
        "type": "bar",
        "title": "",
        "showFilter": true,
        "multipleMeasures": false,
        "oneLevel": false,
        "autoRange": false,
        "reversedAxes": false,
        "showLegendButton": false,
        "showAllLabels": false,
        "showMeasures": true,
        "showOneMeasureSelection": true,
        "showWarning": true,
        "activeMeasure": ""
    },
    "configuratorActive": false,
    "configuratorButton": true,
    "showAggregations": true,
    "showCalculatedValuesButton": true,
    "editing": false,
    "drillThrough": true,
    "showDrillThroughConfigurator": true,
    "sorting": "on",
    "datePattern": "dd/MM/yyyy",
    "dateTimePattern": "dd/MM/yyyy HH:mm:ss",
    "saveAllFormats": false,
    "showDefaultSlice": true,
    "showEmptyData": false,
    "defaultHierarchySortName": "asc",
    "showOutdatedDataAlert": false
}

export default options;